/* lua.js generated code 0.3.0 */

var GameGuideData = require("clover/gameGuide/GameGuideData")
var GameGuidePosition = {}
GameGuidePosition.getPosition = function (posMode, instance, p1, p2, width, height, posRatio, posAdd, sizeRatio) {
    var self = this
    if (type(self[posMode]) === "function") {
        return self[posMode](instance, p1, p2, width, height, posRatio, posAdd, sizeRatio)
    }
    return [0, 0, 0, 0]
}
GameGuidePosition.getTileSize = function(sizeRatio) {
    sizeRatio = sizeRatio || cc.p(1,1);
    var [tWidth, tHeight] = [GamePlayConfig_Tile_Width, GamePlayConfig_Tile_Height];
    var [scaleX, scaleY] = [GamePlayConfig_Tile_ScaleX, GamePlayConfig_Tile_ScaleY];
    return {width: tWidth * scaleX * sizeRatio.x, height: tHeight * scaleY * sizeRatio.y}
}
GameGuidePosition.game = function (instance, r, c, width, height, posRatio, posAdd, sizeRatio) {
    ;[r, c, width, height] = [r || 1, c || 1, width || 0, height || 0]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var scene = cc.Director.getInstance().getRunningScene()
    var sceneName = tostring(((scene || table()).class || table()).__cname)
    if (sceneName !== "GameScene" && sceneName !== "ReplayGameScene") {
        return [0, 0, 0, 0]
    }
    var logic = scene.logic
    if (!logic) {
        return [0, 0, 0, 0]
    }
    var [tWidth, tHeight] = [GamePlayConfig_Tile_Width, GamePlayConfig_Tile_Height]
    var [scaleX, scaleY] = [GamePlayConfig_Tile_ScaleX, GamePlayConfig_Tile_ScaleY]
    var pos = logic.getGameItemPosInView(1, 1)
    let offset = 2.5
    return [pos.x + (c - 1.5) * tWidth * scaleX + tWidth * scaleX * posRatio.x + posAdd.x + offset, pos.y - (r - 0.5) * tHeight * scaleY + tHeight * scaleY * posRatio.y + posAdd.y+ offset, width * tWidth * scaleX * sizeRatio.x, height * tHeight * scaleY * sizeRatio.y ]
}
GameGuidePosition.gameplayArea = function (instance, pos, size, noUse, noUse1, posRatio, posAdd, sizeRatio) {
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var vSize = cc.Director.getInstance().getWinSize()
    var scale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    var topHeight = GamePlayConfig_Top_Height * scale
    pos = pos || cc.p(0, 0)
    size = size || cc.size(vSize.width, vSize.height - topHeight)
    return [pos.x + size.width * posRatio.x + posAdd.x, pos.y + size.height * posRatio.y + posAdd.y, size.width * sizeRatio.x, size.height * sizeRatio.y]
}
GameGuidePosition.homesceneButton = function (instance, p1, noUse, noUse1, noUse2, posRatio, posAdd, sizeRatio) {
    var self = this
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var HomeScene = require("clover/scene/HomeScene")
    var btnLayer = HomeScene.getInstance().btnLayer
    if (btnLayer && btnLayer[p1]) {
        var bound = he.HeDisplayUtil.getNodeGroupBounds(btnLayer[p1], HomeScene, -100)
        // FIXME: multi result
        return [bound.x + bound.width * posRatio.x + posAdd.x, bound.y + bound.height * posRatio.y + posAdd.y, bound.width * sizeRatio.x, bound.height * sizeRatio.y]
    }
    // FIXME: multi result
    return [0, 0, 0, 0]
}
// 暂存的节点
GameGuidePosition.stashNode = function (instance, p1, p2, noUse, noUse1, posRatio, posAdd, sizeRatio) {
    let self = this
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    let node = GameGuideData.getInstance().getStashNode(p1)
    if (node) {
        if (!p2) {
            p2 = node.getContentSize()
        }
        let v00 = node.convertToWorldSpace(cc.p(0, 0))
        let v11 = node.convertToWorldSpace(cc.p(p2.width, p2.height))
        let bound = table(
            [1, "x", v00.x],
            [1, "y", v00.y],
            [1, "width", v11.x - v00.x],
            [1, "height", v11.y - v00.y]
        )
        // FIXME: multi result
        return [bound.x + bound.width * posRatio.x + posAdd.x, bound.y + bound.height * posRatio.y + posAdd.y, bound.width * sizeRatio.x, bound.height * sizeRatio.y]
    }
    // FIXME: multi result
    return [0, 0, 0, 0]
}
GameGuidePosition.levelNode = function (instance, levelId, noUse, noUse1, noUse2, posRatio, posAdd, sizeRatio) {
    levelId = levelId || 1
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var [position, size] = HomeConfigManager.getInstance().getLevelNodePositionAndSize(levelId)
    return [position.x + size.width * posRatio.x + posAdd.x, position.y + size.height * posRatio.y + posAdd.y, size.width * sizeRatio.x, size.height * sizeRatio.y]
}
GameGuidePosition.levelTarget = function (instance, pos, size, noUse, noUse1, posRatio, posAdd, sizeRatio) {
    ;[pos, size] = [(pos || cc.p(0, 0)), (size || cc.size(0, 0))]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var vSize = cc.Director.getInstance().getWinSize()
    var scale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    var topHeight = GamePlayConfig_Top_Height * scale
    var realWidth = vSize.width * scale
    var leftMargin = (vSize.width - realWidth) / 2
    pos = pos || cc.p(0, 0)
    if (size) {
        size = cc.size(size.width * scale, size.height * scale)
    } else {
        size = cc.size(realWidth, topHeight)
    }
    // 解决华为matex宽屏时x坐标偏移问题
    if (vSize.width > GamePlayConfig_Design_Width) {
        leftMargin = leftMargin + (vSize.width - GamePlayConfig_Design_Width) / 2
    }
    return [leftMargin + pos.x * scale + size.width * scale * posRatio.x + posAdd.x, vSize.height - topHeight + pos.y * scale + size.height * scale * posRatio.y + posAdd.y - _safe_area_top, size.width * sizeRatio.x, size.height * sizeRatio.y]
}
GameGuidePosition.panel = function (instance, x, y, width, height, posRatio, posAdd, sizeRatio) {
    ;[x, y, width, height] = [x || 0, y || 0, width || 0, height || 0]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    if (!instance || !instance.nodeExist) {
        return [0, 0, 0, 0]
    }
    var v00 = instance.convertToWorldSpace(cc.p((x || 0), (y || 0)))
    var v11 = instance.convertToWorldSpace(cc.p((x || 0) + (width || 0), (y || 0) + (height || 0)))
    if (type(instance.GuideFunctionForSpecialToGetRect) === "function") {
        ;[v00, v11] = unpack(instance.GuideFunctionForSpecialToGetRect())
    }
    var [position, size] = [cc.p(v00.x, v00.y), cc.size(v11.x - v00.x, v11.y - v00.y)]
    return [position.x + size.width * posRatio.x + posAdd.x, position.y + size.height * posRatio.y + posAdd.y, size.width * sizeRatio.x, size.height * sizeRatio.y]
}
GameGuidePosition.pauseButton = function (instance, noUse, noUse1, noUse2, noUse3, posRatio, posAdd, sizeRatio) {
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var scene = cc.Director.getInstance().getRunningScene()
    var sceneName = tostring(((scene || table()).class || table()).__cname)
    if (sceneName !== "GameScene") {
        return [0, 0, 0, 0]
    }
    var pauseBtn = (scene.ui || table()).pauseBtn
    if (pauseBtn) {
        var size = pauseBtn.getContentSize()
        size = cc.size(size.width * pauseBtn.getScaleX(), size.height * pauseBtn.getScaleY())
        var position = cc.p(pauseBtn.getPosition())
        return [position.x - size.width / 2 + size.width * posRatio.x + posAdd.x, position.y - size.height / 2 + size.height * posRatio.y + posAdd.y, size.width * sizeRatio.x, size.height * sizeRatio.y]
    }
    return [0, 0, 0, 0]
}
GameGuidePosition.propBar = function (instance, index, propId, width, height, posRatio, posAdd, sizeRatio) {
    ;[index, propId, width, height] = [index || 1, propId || null, width || 120, height || 120]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var scene = cc.Director.getInstance().getRunningScene()
    var sceneName = tostring(((scene || table()).class || table()).__cname)
    if (sceneName !== "GameScene") {
        return [0, 0, 0, 0]
    }
    var propBar = (scene.ui || table()).gamePropBar
    if (propBar && propId) {
        var [position, scale] = propBar.getBubblePositionByPropId(propId)
        return [position.x - width * scale / 2 + width * scale * posRatio.x + posAdd.x, position.y - height * scale / 2 + height * scale * posRatio.y + posAdd.y, width * scale * sizeRatio.x, height * scale * sizeRatio.y]
    } else if (propBar) {
        var [position, scale] = propBar.getBubblePositionByIndex(index)
        return [position.x - width * scale / 2 + width * scale * posRatio.x + posAdd.x, position.y - height * scale / 2 + height * scale * posRatio.y + posAdd.y, width * scale * sizeRatio.x, height * scale * sizeRatio.y]
    }
    return [0, 0, 0, 0]
}
GameGuidePosition.stepCounter = function (instance, step, index, width, height, posRatio, posAdd, sizeRatio) {
    ;[step, index, width, height] = [step || false, index || 1, width || 0, height || 0]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    var scene = cc.Director.getInstance().getRunningScene()
    var sceneName = tostring(((scene || table()).class || table()).__cname)
    if (sceneName !== "GameScene") {
        return [0, 0, 0, 0]
    }
    var counter = (scene.ui || table()).stepCounter
    if (counter && step) {
        ;[width, height] = [width || 75, height || 75]
        var [position, scale] = counter.getStepPosition()
        return [position.x - width * scale / 2 + width * scale * posRatio.x + posAdd.x, position.y - height * scale / 2 + height * scale * posRatio.y + posAdd.y, width * scale * sizeRatio.x, height * scale * sizeRatio.y]
    } else if (counter && index) {
        ;[width, height] = [width || 30, height || 30]
        var [position, scale] = counter.getStarPosition(index)
        return [position.x - width * scale / 2 + width * scale * posRatio.x + posAdd.x, position.y - height * scale / 2 + height * scale * posRatio.y + posAdd.y, width * scale * sizeRatio.x, height * scale * sizeRatio.y]
    }
    return [0, 0, 0, 0]
}
GameGuidePosition.ui = function (instance, x, y, width, height, posRatio, posAdd, sizeRatio) {
    var vSize = cc.Director.getInstance().getVisibleSize()
    ;[x, y, width, height] = [x || 0, y || 0, width || 0, height || 0]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    if (vSize.width > GamePlayConfig_Design_Width) {
        posAdd.x = posAdd.x + (vSize.width - GamePlayConfig_Design_Width) / 2
    }
    return [x + width * posRatio.x + posAdd.x, vSize.height - y - height * (1 - posRatio.y) + posAdd.y, width * sizeRatio.x, height * sizeRatio.y]
}
GameGuidePosition.win = function (instance, x, y, width, height, posRatio, posAdd, sizeRatio) {
    ;[x, y, width, height] = [x || 0, y || 0, width || 0, height || 0]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    return [x + width * posRatio.x + posAdd.x, y + height * posRatio.y + posAdd.y, width * sizeRatio.x, height * sizeRatio.y]
}
GameGuidePosition.panelScale = function (instance, x, y, width, height, posRatio, posAdd, sizeRatio) {
    let self = this
    // check 
    if (!instance || !instance.nodeExist) {
        // FIXME: multi result
        return [0, 0, 0, 0]
    }
    // default
    posAdd = posAdd || cc.p(0, 0)
    let scale = display.height / GamePlayConfig_Design_Height
    ;[x, y, width, height] = GameGuidePosition.panel(instance, x, y, width, height, posRatio, cc.p(0, 0), sizeRatio)
    width = width * scale
    height = height * scale
    x = x + posAdd.x * (1 - scale)
    y = y + posAdd.y * (1 - scale)
    // FIXME: multi result
    return [x, y, width, height]
}
GameGuidePosition.newScale = function (instance, x, y, width, height, posRatio, posAdd, sizeRatio) {
    let self = this
    // var 
    let scale = Math.min(GamePlayConfig_RESOLUTION_SCALE, display.width / GamePlayConfig_Design_Width)
    let xoff = (360 - x) * (1 - scale)
    let yoff = -y * (1 - scale)
    posRatio = posRatio || cc.p(0, 0)
    width = (width || 0) * scale
    height = (height || 0) * scale
    x = x + xoff
    y = y + yoff + 640 * (Math.max(1, display.height / 1280) - 1)
    let vSize = cc.Director.getInstance().getWinSize()
    if (vSize.width > GamePlayConfig_Design_Width) {
        x = x + (vSize.width - GamePlayConfig_Design_Width) / 2
    }
    // FIXME: multi result
    return [x, y, width, height]
}
GameGuidePosition.animalCoinTarget = function (instance, x, y, width, height, posRatio, posAdd, sizeRatio) {
    let self = this
    // body
    ;[x, y, width, height] = [x || 0, y || 0, width || 0, height || 0]
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    let scene = cc.Director.getInstance().getRunningScene()
    let pos = null
    if (scene && scene.animalCoinTarget) {
        let node = scene.animalCoinTarget
        pos = node.getParent().convertToWorldSpace(cc.p(node.getPosition()))
        x = pos.x
        y = pos.y
    }
    // FIXME: multi result
    return [x + width * posRatio.x + posAdd.x - width / 2, y + height * posRatio.y + posAdd.y - height / 2, width * sizeRatio.x, height * sizeRatio.y]
}
GameGuidePosition.holeTarget = function (instance, posType, size, width, height, posRatio, posAdd, sizeRatio, param) {
    let self = this
    let [shiftX, shiftY] = [param.shiftX || 0, param.shiftY || 0]
    size = (size || cc.size(0, 0))
    ;[posRatio, posAdd, sizeRatio] = [posRatio || cc.p(0, 0), posAdd || cc.p(0, 0), sizeRatio || cc.p(1, 1)]
    let vSize = cc.Director.getInstance().getWinSize()
    let scaleX, scaleY
    if (param.maxRatio) {
        ;[scaleY, scaleX] = [Math.max(vSize.height / GamePlayConfig_Design_Height, 1), Math.max(vSize.width / GamePlayConfig_Design_Width, 1)]
    } else {
        ;[scaleY, scaleX] = [Math.min(vSize.height / GamePlayConfig_Design_Height, 1), Math.min(vSize.width / GamePlayConfig_Design_Width, 1)]
    }
    let topHeight = GamePlayConfig_Top_Height * scaleY
    let realWidth = vSize.width * scaleX
    let leftMargin = (vSize.width - realWidth) / 2
    let pos = cc.p(0, 0)
    if (size) {
        size = cc.size(size.width * scaleX, size.height * scaleY)
    } else {
        size = cc.size(realWidth, topHeight)
    }
    if (posType === "topLeft") {
        ;[pos.x, pos.y] = [0, vSize.height - size.height - _safe_area_top]
    } else if (posType === "topMid") {
        ;[pos.x, pos.y] = [vSize.width / 2 - size.width / 2, vSize.height - size.height - _safe_area_top]
    } else if (posType === "topRight") {
        ;[pos.x, pos.y] = [vSize.width - size.width, vSize.height - size.height - _safe_area_top]
    } else if (posType === "bottomLeft") {
        ;[pos.x, pos.y] = [0, 0 + _safe_area_bottom]
    } else if (posType === "bottomMid") {
        ;[pos.x, pos.y] = [vSize.width / 2 - size.width / 2, 0 + _safe_area_bottom]
    } else if (posType === "bottomRight") {
        ;[pos.x, pos.y] = [vSize.width - size.width, 0 + _safe_area_bottom]
    }
    // FIXME: multi result
    return [pos.x + shiftX, pos.y + shiftY, size.width * sizeRatio.x, size.height * sizeRatio.y]
}
module.exports = GameGuidePosition
